/* eslint-disable no-nested-ternary */
export const mapOrder = (array, order, key) => {
  array.sort(function x(a, b) {
    const A = a[key]
    const B = b[key]

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1
    }
    return -1
  })

  return array
}

export const otherFunction = () => {
  return ''
}

/**
 * Promisified FileReader
 * More info https://developer.mozilla.org/en-US/docs/Web/API/FileReader
 * @param {*} file
 */
export const readFileAsTextAsync = (file = {}) => {
  const reader = new FileReader()
  return new Promise((resolve, reject) => {
    reader.readAsText(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = error => reject(error)
  })
}

export const findAllByKey = (obj, keyToFind) => {
  return Object.entries(obj).reduce(
    (acc, [key, value]) =>
      key === keyToFind
        ? acc.concat(value)
        : typeof value === 'object' && value
        ? acc.concat(findAllByKey(value, keyToFind))
        : acc,
    [],
  )
}

export const blobToBase64 = blob =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onload = () => resolve(reader.result.substr(reader.result.indexOf(',') + 1))
    reader.onerror = error => reject(error)
  })

export const base64toBlob = (dataURI, mimetype) => {
  if (dataURI?.includes(','))
    // eslint-disable-next-line prefer-destructuring
    dataURI = dataURI.split(',')[1]

  const buffer = Buffer.from(dataURI, 'base64')
  return new Blob([buffer], { type: mimetype })
}

export function deepCopy(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj // Si el objeto no es un objeto (por ejemplo, una cadena), devuelve el valor original
  }

  const clone = Array.isArray(obj) ? [] : {} // Crea un objeto vacío o un array vacío

  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      // Verifica que la propiedad sea del objeto (no heredada)
      clone[key] = deepCopy(obj[key]) // Asigna la copia profunda de la propiedad al objeto clonado
    }
  }
  return clone // Devuelve el objeto clonado
}
